module.exports = __webpack_public_path__ + "static/media/location.88e2c196.svg";